import { default as indexvCICJmsFQHMeta } from "/app/pages/account/bank-account/index.vue?macro=true";
import { default as indexIEoGLQjtNpMeta } from "/app/pages/account/bet-history/index.vue?macro=true";
import { default as indexeP3WCWKNOCMeta } from "/app/pages/account/dashboard/index.vue?macro=true";
import { default as indexHij4hYYaJIMeta } from "/app/pages/account/deposit/index.vue?macro=true";
import { default as index2H7kGmSk1YMeta } from "/app/pages/account/general-promotions/index.vue?macro=true";
import { default as indexQWKFaMHH2OMeta } from "/app/pages/account/index.vue?macro=true";
import { default as indexKCiVKYb9p3Meta } from "/app/pages/account/profile/index.vue?macro=true";
import { default as indexWVTLM4j7HPMeta } from "/app/pages/account/referral/index.vue?macro=true";
import { default as indexqc9t6odmxGMeta } from "/app/pages/account/transaction-history/index.vue?macro=true";
import { default as indexVDPAtjyLK1Meta } from "/app/pages/account/vip/index.vue?macro=true";
import { default as indexbo1r3xrAFHMeta } from "/app/pages/account/withdraw/index.vue?macro=true";
import { default as accountIWnKuvcAuMMeta } from "/app/pages/account.vue?macro=true";
import { default as _91tab_93NEeaV3Qt02Meta } from "/app/pages/bong-da/[tab].vue?macro=true";
import { default as bong_45day6RdUvPJFxMeta } from "/app/pages/bong-da.vue?macro=true";
import { default as indexSgikQ89HLtMeta } from "/app/pages/btisports/index.vue?macro=true";
import { default as index5NZvR36bbiMeta } from "/app/pages/ca-cuoc-the-thao/index.vue?macro=true";
import { default as _91_91type_93_93BWuszQsfcBMeta } from "/app/pages/casino/[[type]].vue?macro=true";
import { default as casinosbhLxYctqdMeta } from "/app/pages/casino.vue?macro=true";
import { default as ga28qinuEbYTkUMeta } from "/app/pages/cockfight/ga28.vue?macro=true";
import { default as indexf8C0JnzdeCMeta } from "/app/pages/cockfight/index.vue?macro=true";
import { default as ws168OB8n7XvAhzMeta } from "/app/pages/cockfight/ws168.vue?macro=true";
import { default as esportskQ72wfhYrwMeta } from "/app/pages/esports.vue?macro=true";
import { default as _91_91type_93_934zlC7QqNqVMeta } from "/app/pages/games/[[type]].vue?macro=true";
import { default as gamesj8mjxaHWCFMeta } from "/app/pages/games.vue?macro=true";
import { default as helpgX3yoxbmc4Meta } from "/app/pages/help.vue?macro=true";
import { default as iconsAVqGQpFjv7Meta } from "/app/pages/icons.vue?macro=true";
import { default as im_45sportssqBNAgutZhMeta } from "/app/pages/im-sports.vue?macro=true";
import { default as index83TZnhLVSTMeta } from "/app/pages/in-play/index.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as indexdzry8iBOY7Meta } from "/app/pages/ksports/index.vue?macro=true";
import { default as _91type_93MYybRlWzbNMeta } from "/app/pages/lode/[type].vue?macro=true";
import { default as index1I5HaweU4LMeta } from "/app/pages/lode/index.vue?macro=true";
import { default as lode_45sieutocKE34oAhXAiMeta } from "/app/pages/lode/lode-sieutoc.vue?macro=true";
import { default as lode3mienZ6pHI9PpJaMeta } from "/app/pages/lode/lode3mien.vue?macro=true";
import { default as _91_91cat_93_93wFu3JdvZL2Meta } from "/app/pages/news/[[cat]].vue?macro=true";
import { default as _91_91postalias_93_93zUz2YDmK2pMeta } from "/app/pages/news/post/[[postalias]].vue?macro=true";
import { default as newsWdQv0BaSvYMeta } from "/app/pages/news.vue?macro=true";
import { default as indexuhAN6NVW9KMeta } from "/app/pages/osports/index.vue?macro=true";
import { default as vipaXjJwIXnwCMeta } from "/app/pages/other/vip.vue?macro=true";
import { default as indexXPFPtZfQvqMeta } from "/app/pages/promotions/index.vue?macro=true";
import { default as indexbTFYubbl2gMeta } from "/app/pages/promotions/promotion-100/index.vue?macro=true";
import { default as indexJY3mCwDiHSMeta } from "/app/pages/promotions/refund-live-casino/index.vue?macro=true";
import { default as index5X4RnUQgZHMeta } from "/app/pages/promotions/refund-slots/index.vue?macro=true";
import { default as indexeyWEAbcGMHMeta } from "/app/pages/promotions/refund-sports/index.vue?macro=true";
import { default as promotionsV1QWs3ugnkMeta } from "/app/pages/promotions.vue?macro=true";
import { default as indexk8DP0SgW3EMeta } from "/app/pages/quayso/index.vue?macro=true";
import { default as numbergame14S5e4ITlkDMeta } from "/app/pages/quayso/numbergame1.vue?macro=true";
import { default as numbergame27W53s2RiQBMeta } from "/app/pages/quayso/numbergame2.vue?macro=true";
import { default as quayso1e3754eg6sOMeta } from "/app/pages/quayso/quayso1.vue?macro=true";
import { default as quayso2BPUTkdijjMMeta } from "/app/pages/quayso/quayso2.vue?macro=true";
import { default as quayso3VANGpZNvuPMeta } from "/app/pages/quayso/quayso3.vue?macro=true";
import { default as quayso5aBR5kasCYoMeta } from "/app/pages/quayso/quayso5.vue?macro=true";
import { default as quaysonQ6f78GmVNMeta } from "/app/pages/quayso.vue?macro=true";
import { default as indexcOHsQL9x7xMeta } from "/app/pages/saba-sports/index.vue?macro=true";
import { default as indexhy9wWwyfDnMeta } from "/app/pages/ssports/index.vue?macro=true";
import { default as testL3AVDvhyXeMeta } from "/app/pages/test.vue?macro=true";
import { default as tro_45giup2hN1hJkhXBMeta } from "/app/pages/tro-giup.vue?macro=true";
import { default as index7ECBaVXTKdMeta } from "/app/pages/tsports/index.vue?macro=true";
import { default as indexeWWBNqLlSHMeta } from "/app/pages/virtual-ksports/index.vue?macro=true";
import { default as indexLTNdUnWEjyMeta } from "/app/pages/virtual-pp-sports/index.vue?macro=true";
import { default as indexZnoEmYyJCOMeta } from "/app/pages/virtual-saba-sports/index.vue?macro=true";
import { default as indexrCSYR1mAavMeta } from "/app/pages/virtual-sport/index.vue?macro=true";
export default [
  {
    name: accountIWnKuvcAuMMeta?.name,
    path: "/en/account",
    meta: accountIWnKuvcAuMMeta || {},
    component: () => import("/app/pages/account.vue"),
    children: [
  {
    name: "account-bank-account___en",
    path: "bank-account",
    meta: indexvCICJmsFQHMeta || {},
    component: () => import("/app/pages/account/bank-account/index.vue")
  },
  {
    name: "account-bet-history___en",
    path: "bet-history",
    meta: indexIEoGLQjtNpMeta || {},
    component: () => import("/app/pages/account/bet-history/index.vue")
  },
  {
    name: "account-dashboard___en",
    path: "dashboard",
    meta: indexeP3WCWKNOCMeta || {},
    component: () => import("/app/pages/account/dashboard/index.vue")
  },
  {
    name: "account-deposit___en",
    path: "deposit",
    component: () => import("/app/pages/account/deposit/index.vue")
  },
  {
    name: "account-general-promotions___en",
    path: "general-promotions",
    meta: index2H7kGmSk1YMeta || {},
    component: () => import("/app/pages/account/general-promotions/index.vue")
  },
  {
    name: "account___en",
    path: "",
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "account-profile___en",
    path: "profile",
    meta: indexKCiVKYb9p3Meta || {},
    component: () => import("/app/pages/account/profile/index.vue")
  },
  {
    name: "account-referral___en",
    path: "referral",
    meta: indexWVTLM4j7HPMeta || {},
    component: () => import("/app/pages/account/referral/index.vue")
  },
  {
    name: "account-transaction-history___en",
    path: "transaction-history",
    meta: indexqc9t6odmxGMeta || {},
    component: () => import("/app/pages/account/transaction-history/index.vue")
  },
  {
    name: "account-vip___en",
    path: "vip",
    meta: indexVDPAtjyLK1Meta || {},
    component: () => import("/app/pages/account/vip/index.vue")
  },
  {
    name: "account-withdraw___en",
    path: "withdraw",
    component: () => import("/app/pages/account/withdraw/index.vue")
  }
]
  },
  {
    name: accountIWnKuvcAuMMeta?.name,
    path: "/account",
    meta: accountIWnKuvcAuMMeta || {},
    component: () => import("/app/pages/account.vue"),
    children: [
  {
    name: "account-bank-account___vi",
    path: "bank-account",
    meta: indexvCICJmsFQHMeta || {},
    component: () => import("/app/pages/account/bank-account/index.vue")
  },
  {
    name: "account-bet-history___vi",
    path: "bet-history",
    meta: indexIEoGLQjtNpMeta || {},
    component: () => import("/app/pages/account/bet-history/index.vue")
  },
  {
    name: "account-dashboard___vi",
    path: "dashboard",
    meta: indexeP3WCWKNOCMeta || {},
    component: () => import("/app/pages/account/dashboard/index.vue")
  },
  {
    name: "account-deposit___vi",
    path: "deposit",
    component: () => import("/app/pages/account/deposit/index.vue")
  },
  {
    name: "account-general-promotions___vi",
    path: "general-promotions",
    meta: index2H7kGmSk1YMeta || {},
    component: () => import("/app/pages/account/general-promotions/index.vue")
  },
  {
    name: "account___vi",
    path: "",
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "account-profile___vi",
    path: "profile",
    meta: indexKCiVKYb9p3Meta || {},
    component: () => import("/app/pages/account/profile/index.vue")
  },
  {
    name: "account-referral___vi",
    path: "referral",
    meta: indexWVTLM4j7HPMeta || {},
    component: () => import("/app/pages/account/referral/index.vue")
  },
  {
    name: "account-transaction-history___vi",
    path: "transaction-history",
    meta: indexqc9t6odmxGMeta || {},
    component: () => import("/app/pages/account/transaction-history/index.vue")
  },
  {
    name: "account-vip___vi",
    path: "vip",
    meta: indexVDPAtjyLK1Meta || {},
    component: () => import("/app/pages/account/vip/index.vue")
  },
  {
    name: "account-withdraw___vi",
    path: "withdraw",
    component: () => import("/app/pages/account/withdraw/index.vue")
  }
]
  },
  {
    name: "bong-da___en",
    path: "/en/bong-da",
    component: () => import("/app/pages/bong-da.vue"),
    children: [
  {
    name: "bong-da-tab___en",
    path: ":tab()",
    component: () => import("/app/pages/bong-da/[tab].vue")
  }
]
  },
  {
    name: "bong-da___vi",
    path: "/bong-da",
    component: () => import("/app/pages/bong-da.vue"),
    children: [
  {
    name: "bong-da-tab___vi",
    path: ":tab()",
    component: () => import("/app/pages/bong-da/[tab].vue")
  }
]
  },
  {
    name: "btisports___en",
    path: "/en/btisports",
    meta: indexSgikQ89HLtMeta || {},
    component: () => import("/app/pages/btisports/index.vue")
  },
  {
    name: "btisports___vi",
    path: "/btisports",
    meta: indexSgikQ89HLtMeta || {},
    component: () => import("/app/pages/btisports/index.vue")
  },
  {
    name: "ca-cuoc-the-thao___en",
    path: "/en/ca-cuoc-the-thao",
    component: () => import("/app/pages/ca-cuoc-the-thao/index.vue")
  },
  {
    name: "ca-cuoc-the-thao___vi",
    path: "/ca-cuoc-the-thao",
    component: () => import("/app/pages/ca-cuoc-the-thao/index.vue")
  },
  {
    name: "casino___en",
    path: "/en/casino",
    component: () => import("/app/pages/casino.vue"),
    children: [
  {
    name: "casino-type___en",
    path: ":type?",
    component: () => import("/app/pages/casino/[[type]].vue")
  }
]
  },
  {
    name: "casino___vi",
    path: "/casino",
    component: () => import("/app/pages/casino.vue"),
    children: [
  {
    name: "casino-type___vi",
    path: ":type?",
    component: () => import("/app/pages/casino/[[type]].vue")
  }
]
  },
  {
    name: "cockfight-ga28___en",
    path: "/en/cockfight/ga28",
    component: () => import("/app/pages/cockfight/ga28.vue")
  },
  {
    name: "cockfight-ga28___vi",
    path: "/cockfight/ga28",
    component: () => import("/app/pages/cockfight/ga28.vue")
  },
  {
    name: "cockfight___en",
    path: "/en/cockfight",
    component: () => import("/app/pages/cockfight/index.vue")
  },
  {
    name: "cockfight___vi",
    path: "/cockfight",
    component: () => import("/app/pages/cockfight/index.vue")
  },
  {
    name: "cockfight-ws168___en",
    path: "/en/cockfight/ws168",
    component: () => import("/app/pages/cockfight/ws168.vue")
  },
  {
    name: "cockfight-ws168___vi",
    path: "/cockfight/ws168",
    component: () => import("/app/pages/cockfight/ws168.vue")
  },
  {
    name: "esports___en",
    path: "/en/esports",
    component: () => import("/app/pages/esports.vue")
  },
  {
    name: "esports___vi",
    path: "/esports",
    component: () => import("/app/pages/esports.vue")
  },
  {
    name: "games___en",
    path: "/en/games",
    component: () => import("/app/pages/games.vue"),
    children: [
  {
    name: "games-type___en",
    path: ":type?",
    component: () => import("/app/pages/games/[[type]].vue")
  }
]
  },
  {
    name: "games___vi",
    path: "/games",
    component: () => import("/app/pages/games.vue"),
    children: [
  {
    name: "games-type___vi",
    path: ":type?",
    component: () => import("/app/pages/games/[[type]].vue")
  }
]
  },
  {
    name: "help___en",
    path: "/en/help",
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___vi",
    path: "/help",
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "icons___en",
    path: "/en/icons",
    component: () => import("/app/pages/icons.vue")
  },
  {
    name: "icons___vi",
    path: "/icons",
    component: () => import("/app/pages/icons.vue")
  },
  {
    name: "im-sports___en",
    path: "/en/im-sports",
    meta: im_45sportssqBNAgutZhMeta || {},
    component: () => import("/app/pages/im-sports.vue")
  },
  {
    name: "im-sports___vi",
    path: "/im-sports",
    meta: im_45sportssqBNAgutZhMeta || {},
    component: () => import("/app/pages/im-sports.vue")
  },
  {
    name: "in-play___en",
    path: "/en/in-play",
    meta: index83TZnhLVSTMeta || {},
    component: () => import("/app/pages/in-play/index.vue")
  },
  {
    name: "in-play___vi",
    path: "/in-play",
    meta: index83TZnhLVSTMeta || {},
    component: () => import("/app/pages/in-play/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___vi",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "ksports___en",
    path: "/en/ksports",
    component: () => import("/app/pages/ksports/index.vue")
  },
  {
    name: "ksports___vi",
    path: "/ksports",
    component: () => import("/app/pages/ksports/index.vue")
  },
  {
    name: "lode-type___en",
    path: "/en/lode/:type()",
    meta: _91type_93MYybRlWzbNMeta || {},
    component: () => import("/app/pages/lode/[type].vue")
  },
  {
    name: "lode-type___vi",
    path: "/lode/:type()",
    meta: _91type_93MYybRlWzbNMeta || {},
    component: () => import("/app/pages/lode/[type].vue")
  },
  {
    name: "lode___en",
    path: "/en/lode",
    component: () => import("/app/pages/lode/index.vue")
  },
  {
    name: "lode___vi",
    path: "/lode",
    component: () => import("/app/pages/lode/index.vue")
  },
  {
    name: "lode-lode-sieutoc___en",
    path: "/en/lode/lode-sieutoc",
    component: () => import("/app/pages/lode/lode-sieutoc.vue")
  },
  {
    name: "lode-lode-sieutoc___vi",
    path: "/lode/lode-sieutoc",
    component: () => import("/app/pages/lode/lode-sieutoc.vue")
  },
  {
    name: "lode-lode3mien___en",
    path: "/en/lode/lode3mien",
    meta: lode3mienZ6pHI9PpJaMeta || {},
    component: () => import("/app/pages/lode/lode3mien.vue")
  },
  {
    name: "lode-lode3mien___vi",
    path: "/lode/lode3mien",
    meta: lode3mienZ6pHI9PpJaMeta || {},
    component: () => import("/app/pages/lode/lode3mien.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    component: () => import("/app/pages/news.vue"),
    children: [
  {
    name: "news-cat___en",
    path: ":cat?",
    component: () => import("/app/pages/news/[[cat]].vue")
  },
  {
    name: "news-post-postalias___en",
    path: "post/:postalias?",
    component: () => import("/app/pages/news/post/[[postalias]].vue")
  }
]
  },
  {
    name: "news___vi",
    path: "/news",
    component: () => import("/app/pages/news.vue"),
    children: [
  {
    name: "news-cat___vi",
    path: ":cat?",
    component: () => import("/app/pages/news/[[cat]].vue")
  },
  {
    name: "news-post-postalias___vi",
    path: "post/:postalias?",
    component: () => import("/app/pages/news/post/[[postalias]].vue")
  }
]
  },
  {
    name: "osports___en",
    path: "/en/osports",
    meta: indexuhAN6NVW9KMeta || {},
    component: () => import("/app/pages/osports/index.vue")
  },
  {
    name: "osports___vi",
    path: "/osports",
    meta: indexuhAN6NVW9KMeta || {},
    component: () => import("/app/pages/osports/index.vue")
  },
  {
    name: "other-vip___en",
    path: "/en/other/vip",
    meta: vipaXjJwIXnwCMeta || {},
    component: () => import("/app/pages/other/vip.vue")
  },
  {
    name: "other-vip___vi",
    path: "/other/vip",
    meta: vipaXjJwIXnwCMeta || {},
    component: () => import("/app/pages/other/vip.vue")
  },
  {
    name: promotionsV1QWs3ugnkMeta?.name,
    path: "/en/promotions",
    component: () => import("/app/pages/promotions.vue"),
    children: [
  {
    name: "promotions___en",
    path: "",
    component: () => import("/app/pages/promotions/index.vue")
  },
  {
    name: "promotions-promotion-100___en",
    path: "promotion-100",
    component: () => import("/app/pages/promotions/promotion-100/index.vue")
  },
  {
    name: "promotions-refund-live-casino___en",
    path: "refund-live-casino",
    component: () => import("/app/pages/promotions/refund-live-casino/index.vue")
  },
  {
    name: "promotions-refund-slots___en",
    path: "refund-slots",
    component: () => import("/app/pages/promotions/refund-slots/index.vue")
  },
  {
    name: "promotions-refund-sports___en",
    path: "refund-sports",
    component: () => import("/app/pages/promotions/refund-sports/index.vue")
  }
]
  },
  {
    name: promotionsV1QWs3ugnkMeta?.name,
    path: "/promotions",
    component: () => import("/app/pages/promotions.vue"),
    children: [
  {
    name: "promotions___vi",
    path: "",
    component: () => import("/app/pages/promotions/index.vue")
  },
  {
    name: "promotions-promotion-100___vi",
    path: "promotion-100",
    component: () => import("/app/pages/promotions/promotion-100/index.vue")
  },
  {
    name: "promotions-refund-live-casino___vi",
    path: "refund-live-casino",
    component: () => import("/app/pages/promotions/refund-live-casino/index.vue")
  },
  {
    name: "promotions-refund-slots___vi",
    path: "refund-slots",
    component: () => import("/app/pages/promotions/refund-slots/index.vue")
  },
  {
    name: "promotions-refund-sports___vi",
    path: "refund-sports",
    component: () => import("/app/pages/promotions/refund-sports/index.vue")
  }
]
  },
  {
    name: quaysonQ6f78GmVNMeta?.name,
    path: "/en/quayso",
    component: () => import("/app/pages/quayso.vue"),
    children: [
  {
    name: "quayso___en",
    path: "",
    component: () => import("/app/pages/quayso/index.vue")
  },
  {
    name: "quayso-numbergame1___en",
    path: "numbergame1",
    component: () => import("/app/pages/quayso/numbergame1.vue")
  },
  {
    name: "quayso-numbergame2___en",
    path: "numbergame2",
    component: () => import("/app/pages/quayso/numbergame2.vue")
  },
  {
    name: "quayso-quayso1___en",
    path: "quayso1",
    component: () => import("/app/pages/quayso/quayso1.vue")
  },
  {
    name: "quayso-quayso2___en",
    path: "quayso2",
    component: () => import("/app/pages/quayso/quayso2.vue")
  },
  {
    name: "quayso-quayso3___en",
    path: "quayso3",
    component: () => import("/app/pages/quayso/quayso3.vue")
  },
  {
    name: "quayso-quayso5___en",
    path: "quayso5",
    component: () => import("/app/pages/quayso/quayso5.vue")
  }
]
  },
  {
    name: quaysonQ6f78GmVNMeta?.name,
    path: "/quayso",
    component: () => import("/app/pages/quayso.vue"),
    children: [
  {
    name: "quayso___vi",
    path: "",
    component: () => import("/app/pages/quayso/index.vue")
  },
  {
    name: "quayso-numbergame1___vi",
    path: "numbergame1",
    component: () => import("/app/pages/quayso/numbergame1.vue")
  },
  {
    name: "quayso-numbergame2___vi",
    path: "numbergame2",
    component: () => import("/app/pages/quayso/numbergame2.vue")
  },
  {
    name: "quayso-quayso1___vi",
    path: "quayso1",
    component: () => import("/app/pages/quayso/quayso1.vue")
  },
  {
    name: "quayso-quayso2___vi",
    path: "quayso2",
    component: () => import("/app/pages/quayso/quayso2.vue")
  },
  {
    name: "quayso-quayso3___vi",
    path: "quayso3",
    component: () => import("/app/pages/quayso/quayso3.vue")
  },
  {
    name: "quayso-quayso5___vi",
    path: "quayso5",
    component: () => import("/app/pages/quayso/quayso5.vue")
  }
]
  },
  {
    name: "saba-sports___en",
    path: "/en/saba-sports",
    meta: indexcOHsQL9x7xMeta || {},
    component: () => import("/app/pages/saba-sports/index.vue")
  },
  {
    name: "saba-sports___vi",
    path: "/saba-sports",
    meta: indexcOHsQL9x7xMeta || {},
    component: () => import("/app/pages/saba-sports/index.vue")
  },
  {
    name: "ssports___en",
    path: "/en/ssports",
    meta: indexhy9wWwyfDnMeta || {},
    component: () => import("/app/pages/ssports/index.vue")
  },
  {
    name: "ssports___vi",
    path: "/ssports",
    meta: indexhy9wWwyfDnMeta || {},
    component: () => import("/app/pages/ssports/index.vue")
  },
  {
    name: "test___en",
    path: "/en/test",
    component: () => import("/app/pages/test.vue")
  },
  {
    name: "test___vi",
    path: "/test",
    component: () => import("/app/pages/test.vue")
  },
  {
    name: "tro-giup___en",
    path: "/en/tro-giup",
    component: () => import("/app/pages/tro-giup.vue")
  },
  {
    name: "tro-giup___vi",
    path: "/tro-giup",
    component: () => import("/app/pages/tro-giup.vue")
  },
  {
    name: "tsports___en",
    path: "/en/tsports",
    meta: index7ECBaVXTKdMeta || {},
    component: () => import("/app/pages/tsports/index.vue")
  },
  {
    name: "tsports___vi",
    path: "/tsports",
    meta: index7ECBaVXTKdMeta || {},
    component: () => import("/app/pages/tsports/index.vue")
  },
  {
    name: "virtual-ksports___en",
    path: "/en/virtual-ksports",
    meta: indexeWWBNqLlSHMeta || {},
    component: () => import("/app/pages/virtual-ksports/index.vue")
  },
  {
    name: "virtual-ksports___vi",
    path: "/virtual-ksports",
    meta: indexeWWBNqLlSHMeta || {},
    component: () => import("/app/pages/virtual-ksports/index.vue")
  },
  {
    name: "virtual-pp-sports___en",
    path: "/en/virtual-pp-sports",
    component: () => import("/app/pages/virtual-pp-sports/index.vue")
  },
  {
    name: "virtual-pp-sports___vi",
    path: "/virtual-pp-sports",
    component: () => import("/app/pages/virtual-pp-sports/index.vue")
  },
  {
    name: "virtual-saba-sports___en",
    path: "/en/virtual-saba-sports",
    meta: indexZnoEmYyJCOMeta || {},
    component: () => import("/app/pages/virtual-saba-sports/index.vue")
  },
  {
    name: "virtual-saba-sports___vi",
    path: "/virtual-saba-sports",
    meta: indexZnoEmYyJCOMeta || {},
    component: () => import("/app/pages/virtual-saba-sports/index.vue")
  },
  {
    name: "virtual-sport___en",
    path: "/en/virtual-sport",
    component: () => import("/app/pages/virtual-sport/index.vue")
  },
  {
    name: "virtual-sport___vi",
    path: "/virtual-sport",
    component: () => import("/app/pages/virtual-sport/index.vue")
  }
]